import React, {useState, useEffect} from 'react';
import styled from "styled-components";

const StarRatings = ({count = 5, size = 24, default_rate = 0, activeColor, onChange, icon, className}) => {
    const [currentRating, setCurrentRating] = useState(default_rate);

    const hoverHandler = ev => {
        const stars = ev.target.closest('.star-ratings').getElementsByClassName('star');
        const hoverValue = ev.target.closest('.star').dataset.value;
        Array.from(stars).forEach(star => {
            if (hoverValue >= star.dataset.value) {
                star.classList.add('active');
            } else {
                star.classList.remove('active');
            }
        });
    };

    const handleLeaveHover = ev => {
        const stars = ev.target.closest('.star-ratings').getElementsByClassName('star');
        Array.from(stars).forEach(star => {
            if (currentRating >= star.dataset.value) {
                star.classList.add('active');
            } else {
                star.classList.remove('active');
            }
        });
    };

    const starClickHandler = ev => {
        let rating = ev.target.closest('.star').dataset.value;
        setCurrentRating(rating);
        if (typeof onChange !== "undefined") {
            onChange(rating)
        }
    };

    return (
        <div
            onMouseLeave={handleLeaveHover}
            className="star-ratings d-flex flex-row-reverse align-items-center justify-content-center">
            {[...Array(+count).keys()].map(n => {
                return (
                    <Star
                        size={size}
                        className={"star " + ((default_rate >= n + 1) ? 'active' : '')}
                        key={n + 1}
                        data-value={n + 1}
                        onMouseEnter={hoverHandler}

                        onClick={starClickHandler}
                    >
                        {
                            (typeof icon !== "undefined") ?
                                icon
                                : <i>&#9733;</i>
                        }
                    </Star>
                );
            })}
        </div>
    );
};

export default StarRatings;

// styles

const Star = styled.div`
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    margin-right: 4px;
    
    &:last-child {
        margin-right: 0;
    }
    
    i,svg {
        cursor: pointer;
        width: 100%;
        height: 100%;
        
        path {
            stroke-width: 1px;
        }
    }
`;
